"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSportradarCasbinModel = void 0;
const casbin_1 = require("casbin");
const getSportradarCasbinModel = function () {
    const sportradarCasbinModel = (0, casbin_1.newModel)();
    sportradarCasbinModel.addDef('r', 'r', 'sub, act, obj');
    sportradarCasbinModel.addDef('p', 'p', 'sub, act, obj');
    sportradarCasbinModel.addDef('g', 'g', '_, _');
    sportradarCasbinModel.addDef('e', 'e', 'some(where (p.eft == allow))');
    sportradarCasbinModel.addDef('m', 'm', 'g(r.sub, p.sub) && srn_matcher(r.obj, p.obj) && regexMatch(r.act, p.act)');
    return sportradarCasbinModel;
};
exports.getSportradarCasbinModel = getSportradarCasbinModel;
//# sourceMappingURL=SportradarCasbinModel.js.map